const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

export const LAST_LOGIN_ROUTE_KEY = "locsy_last_login_route";

export const KNOWN_LOGIN_ROUTES = [
  "/app-admin-operator/login",
  "/aalogin",
  "/user-login",
  "/locsydashboard",
  "/locsy/admin/login",
  "/locsy/operator/login",
  "/business-admin-operator/login",
];

export function istDayKey(ms = Date.now()) {
  const ist = new Date(Number(ms) + IST_OFFSET_MS);
  const y = ist.getUTCFullYear();
  const m = String(ist.getUTCMonth() + 1).padStart(2, "0");
  const d = String(ist.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function isAppOperatorRole(decoded) {
  const role = String(decoded?.role || decoded?.type || "")
    .trim()
    .toLowerCase();
  return role === "app_operator";
}

/** App-operator session is valid for the IST day it was issued. */
export function isAppOperatorDailySessionExpired(decoded) {
  if (!decoded || !isAppOperatorRole(decoded)) return false;
  if (decoded.exp && Number(decoded.exp) * 1000 < Date.now()) return true;
  if (decoded.iat) {
    return istDayKey(Number(decoded.iat) * 1000) !== istDayKey(Date.now());
  }
  return false;
}

export function loginRouteForRole(role) {
  const normalized = String(role || "")
    .trim()
    .toLowerCase();
  if (normalized === "app_operator") return "/app-admin-operator/login";
  if (normalized === "user" || normalized === "customer") return "/user-login";
  if (
    normalized === "franchisee_admin" ||
    normalized === "net_center_admin" ||
    normalized === "franchisee_operator"
  ) {
    return "/locsydashboard";
  }
  return "/aalogin";
}

export function rememberLoginRoute(role) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(LAST_LOGIN_ROUTE_KEY, loginRouteForRole(role));
}

export function getRememberedLoginRoute() {
  if (typeof window === "undefined") return "/aalogin";
  const stored = window.localStorage.getItem(LAST_LOGIN_ROUTE_KEY);
  if (stored && KNOWN_LOGIN_ROUTES.includes(stored)) return stored;
  return "/aalogin";
}
